export default {
  fields: [
    {
      key: 'id',
      label: '№',
      // sortable: true,
    },
    {
      key: 'MANAGER',
      label: 'Менеджер',
      // sortable: true,
      tdClass: 'w_g',
    },
    {
      key: 'BASISDEBT',
      label: 'Сумма долга',
      // sortable: true,
    },
    {
      key: 'pay_his',
      label: 'Последние платежи',
      // sortable: false,
    },
    {
      key: 'LAST_ACTION_DATE',
      label: 'ДАТА ПОСЛЕДНЕГО ДЕЙСТВИЯ',
      // sortable: true,
    },
    {
      key: 'debtors',
      label: 'Должники',
      // sortable: true,
    },
    {
      key: 'BORROWER.CITY',
      label: 'Город',
      // sortable: true,
    },
    {
      key: 'BELONGING',
      label: 'Принадлежность',
      // sortable: false,
    },
    {
      key: 'CLAIMER_COMPANY_NAME',
      label: 'Взыскатель',
      // sortable: true,
    },
    {
      key: 'EXECUTIVE_DOC_STATUS',
      label: 'Статус ИД',
      // sortable: true,
    },
    {
      key: 'BASIS',
      label: 'Стадия',
      // sortable: true,
    },
  ],
}
